// @flow

import React from 'react'

import withMetricClick from '../../../withMetricClick'
import SocialIcon from './SocialIcon'
import MobileShareDropdown from './MobileShareDropdown'
import type { ModalTypes } from '../../../redux'

let styles = {}

type Props = {
  openModal: (modalType: ModalTypes) => void,
  mapUrl: ?string,
  calendarUrl: ?string
}

const SocialIcons = ({ mapUrl, calendarUrl, openModal }: Props) => {
  const ShareIconWithMetricClick = withMetricClick('share-modal-open')(
    SocialIcon
  )
  const MapIconWithMetricClick = withMetricClick('viewmap')(SocialIcon)
  const CalendarIconWithMetricClick = withMetricClick('addcal')(SocialIcon)
  return (
    <div style={styles.wrapper}>
      <span className="mobile only" data-testid="share-dropdown">
        <MobileShareDropdown
          mapUrl={mapUrl}
          calendarUrl={calendarUrl}
          openModal={openModal}
        />
      </span>
      <span className="mobile hidden" style={styles.iconWrapper}>
        <div data-testid="share-button">
          <ShareIconWithMetricClick
            size="large"
            label="Share"
            icon="share alternate"
            className="shareModal__trigger"
            onClick={() => openModal('share')}
          />
        </div>
        {mapUrl && (
          <a
            target="_blank"
            href={mapUrl}
            style={styles.socialIconLink}
            data-testid="map-button"
          >
            <MapIconWithMetricClick
              size="large"
              icon="map outline"
              label="View on a map"
            />
          </a>
        )}
        {calendarUrl && (
          <a
            target="_blank"
            href={calendarUrl}
            style={styles.socialIconLink}
            data-testid="calendar-button"
          >
            <CalendarIconWithMetricClick
              size="large"
              icon="calendar"
              label="Add to calendar"
            />
          </a>
        )}
      </span>
    </div>
  )
}

styles = {
  wrapper: {
    color: '#fff',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  iconWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-end'
  },
  socialIconLink: { textDecoration: 'none' }
}

export default SocialIcons



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/FlyerDetailMenu/components/SocialIcons.js